import { FC, useState } from 'react'

import styled from 'styled-components'

import Icon from 'core/components/Icon'
import { variables } from 'core/styles'

import Button from '../Button'
import { Tippy } from '../Tooltip'

type ClipboardCopyButtonProps = {
  children?: string
  value?: string
  copyMessage?: string
  confirmedMessage?: string
}

export const ClipboardCopyButton: FC<ClipboardCopyButtonProps> = ({
  children,
  value,
  copyMessage,
  confirmedMessage = 'Copied!',
}) => {
  const [visible, setVisible] = useState(false)
  const [clicked, setClicked] = useState(false)

  function handleClick() {
    if (!clicked) {
      navigator.clipboard.writeText(String(value)).then(() => {
        setClicked(true)
        setVisible(true)
        setTimeout(() => setVisible(false), 1000)
      })
    }
  }

  function handleMouseEnter() {
    if (copyMessage && !clicked && !visible) {
      setVisible(true)
    }
  }

  function handleMouseLeave() {
    if (!clicked && visible) {
      setVisible(false)
    }
  }

  return (
    <Tippy
      content={clicked ? confirmedMessage : copyMessage}
      theme='light'
      placement='bottom'
      className='tooltip'
      visible={visible}
      onHidden={() => setClicked(false)}
    >
      <StyledButton
        secondary
        type='button'
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Icon name='content_copy' fontSize='26px' color={variables.colorBluePrimary} />
        {children}
      </StyledButton>
    </Tippy>
  )
}

const StyledButton = styled(Button)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
`
